import React, { useContext } from "react";
import { apiPut } from "../../utils/apiFetch";
import apiPath from "utils/apiPath";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { isEmpty } from "lodash";
import helpers from "../../utils/helpers";
import OServiceTableHead from "components/reusable/OTableHead";
import { NavLink, useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import OModal from "components/reusable/OModal";
const Table = ({ announcements, getAllAnnouncements, page, sort, setSort, manager }) => {

  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const navigate = useNavigate()
  const notification = useToastContext();

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.spServiceStatus === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.servicePriceChangeStatus}/status-change/${item?.spService?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllAnnouncements();
      }
    } catch (error) {
      console.error("error in get all list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">

      <div className="overflow-x-auto rounded-lg border relative">
        <table className="dark:text-gray-400 w-full text-xs  text-[#A5A5A5] text-left ">
          <thead className="text-xs text-gray-900 border  bg-[#E1E6EE] dark:bg-gray-700 border-[#E1E6EE] dark:text-gray-400">
            <tr>

              <th scope="col" className="py-3 px-6 text-center">
                {t("S.NO")}
              </th>
              <OServiceTableHead sort={sort} fieldName="name" setSort={setSort} name="Service" />
              <th scope="col" className="py-3 px-3 ">
                {t("TITLE")}
              </th>
              <OServiceTableHead sort={sort} fieldName="description" setSort={setSort} name="DESCRIPTION" />
              <OServiceTableHead sort={sort} fieldName="updatedAt" setSort={setSort} name="CREATED_AT" classTd="justify-center" />
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>

          <tbody >
            {announcements?.map((item, i) => (

              <tr key={item?.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700" >

                <th scope="row" className="py-2 px-4 border-r font-medium text-gray-900 text-center dark:text-white">
                  {i + 1 + 10 * (page - 1)}
                </th>
                <td className="py-2 px-3 border-r">
                  {helpers.capitalizeFirstWord(item?.serviceName)}

                </td>
                <td className="py-2 px-3 border-r">
                  {helpers.capitalizeFirstWord(item?.title)}

                </td>

                <OModal
                  trigger={<td className={`py-2 px-3 border-r dark:border-[#ffffff38] ${helpers.ternaryCondition(item?.description?.length > 60, ' cursor-pointer', '')}`} onClick={(e) => item?.description?.length < 60 && e.preventDefault()}>{helpers.ternaryCondition(item?.description?.length > 60, `${item?.description?.slice(0, 60)?.trim()}... `, item?.description)}</td>}
                  title={'View Description'}
                >
                  <td className="py-2 px-1 break-all">{helpers.capitalizeFirstWord(item?.description)}</td>
                </OModal>

                <td className="py-2 px-3 border-r text-center">
                  {helpers.getDateAndTime(item?.createdAt)}
                </td>
                <td className="py-2 border-l px-4">
                  <div className="">
                    <ul className="flex justify-center">

                      <li
                        onClick={() => {
                          navigate('view', { state: { ...item } });

                        }}
                        className="px-2 py-2 dark:hover:bg-transparent hover:bg-white hover:text-LightBlue"
                        title={t("O_VIEW")}
                      >
                        <AiFillEye className="text-slate-600 w-5 h-5  cursor-pointer" />
                      </li>

                    </ul>
                  </div>
                </td>
              </tr>

            ))}
            {isEmpty(announcements) ? (
              <tr className="bg-whitedark:bg-gray-800 dark:border-gray-700 text-center border-b w-full ">
                <td colSpan={12} className="py-4 px-6">
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>

        </table>

      </div>
    </div>
  );
};

export default Table;
